import Vue from 'vue'
import App from './App.vue'
import store from './store'
import stringManager from './stringManager'

Vue.config.productionTip = false
Vue.use(stringManager)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
